import { CSSObject } from '@chakra-ui/react';

export const HeaderContainer = (): CSSObject => ({
  position: 'relative',
  py: '2',
  w: 'fill-available',
  px: '1',
  borderRadius: 'none',
  color: 'white',
  boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.20)',
  borderBottom: [null, null, null, '1px'],
  '&&': {
    borderBottomColor: 'blackAlpha.300',
  },
});

export const FlexIconPropName: CSSObject = {
  gap: '2',
};

export const SpanBarrierNumber: CSSObject = {
  fontSize: 'xs',
  color: 'white',
};

export const TextSubtitle: CSSObject = {
  color: 'alpha.200',
};

export const IconOddsChangeArrow = (direction: 'increase' | 'decrease') => ({
  color: direction === 'increase' ? 'alpha.400' : 'red.300',
});
